import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import NotificationsOffRoundedIcon from '@mui/icons-material/NotificationsOffRounded';
import { ativarPush, desativarPush, estadoPush } from '../utils/pushNativo';
import { ehIOS, rodandoComoApp } from '../utils/pwa';
import tokens from '../theme/tokens';

const TEXTO = {
  ativo: 'Você recebe os avisos da pelada neste aparelho, mesmo com o app fechado.',
  inativo: 'Ative para receber os avisos da pelada neste aparelho, mesmo com o app fechado.',
  bloqueado: 'As notificações estão bloqueadas no navegador. Libere nas configurações do site para ativar.',
  indisponivel: 'Este navegador não recebe notificações.',
};

/**
 * Liga/desliga o push nativo neste aparelho. `somenteSeInativo`: some quando já está ativo
 * (usado no topo da lista de notificações).
 */
const PushAparelhoCard = ({ sx, onMessage, somenteSeInativo = false }) => {
  const [estado, setEstado] = useState(null);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    estadoPush().then(setEstado);
  }, []);

  if (!estado || (somenteSeInativo && (estado === 'ativo' || estado === 'indisponivel'))) return null;
  const ativo = estado === 'ativo';
  const iosSemApp = estado === 'indisponivel' && ehIOS() && !rodandoComoApp();

  const alternar = async () => {
    setSalvando(true);
    const resultado = ativo ? await desativarPush() : await ativarPush();
    setEstado(await estadoPush());
    setSalvando(false);
    if (onMessage) {
      if (resultado.ok) onMessage(ativo ? 'Notificações desativadas neste aparelho.' : 'Notificações ativadas neste aparelho!', 'success');
      else onMessage(resultado.message, 'error');
    }
  };

  return (
    <Card sx={{ p: 2, borderColor: ativo ? tokens.color.success : undefined, bgcolor: ativo ? tokens.color.successSoft : undefined, ...sx }}>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box sx={{ width: 40, height: 40, borderRadius: 2, flexShrink: 0, display: 'grid', placeItems: 'center', bgcolor: ativo ? tokens.color.success : tokens.color.surfaceAlt, color: ativo ? '#fff' : 'text.secondary' }}>
          {ativo ? <NotificationsActiveRoundedIcon /> : <NotificationsOffRoundedIcon />}
        </Box>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography fontWeight={700}>Notificações neste aparelho</Typography>
          <Typography variant="body2" color="text.secondary">
            {iosSemApp ? 'No iPhone, adicione o app à tela de início (Compartilhar › Adicionar à Tela de Início) para receber notificações.' : TEXTO[estado]}
          </Typography>
        </Box>
        {(estado === 'ativo' || estado === 'inativo') && (
          <Switch checked={ativo} onChange={alternar} disabled={salvando} inputProps={{ 'aria-label': 'Notificações neste aparelho' }} />
        )}
      </Stack>
    </Card>
  );
};

export default PushAparelhoCard;
